const appConfig = {
    apiUrl: 'http://flow_backend.local/api',
}

export default appConfig;